/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecommendCodeBindPageItemVo
 */
export interface RecommendCodeBindPageItemVo {
    /**
     * 邀新会员id
     * @type {number}
     * @memberof RecommendCodeBindPageItemVo
     */
    userId?: number;
    /**
     * 会员编号
     * @type {string}
     * @memberof RecommendCodeBindPageItemVo
     */
    userCode?: string;
    /**
     * 会员名
     * @type {string}
     * @memberof RecommendCodeBindPageItemVo
     */
    userName?: string;
    /**
     * 推荐码（该会员注册时填入的推荐码）
     * @type {string}
     * @memberof RecommendCodeBindPageItemVo
     */
    recommendCode?: string;
    /**
     * 出库完成数（佣金记录中去重订单数）
     * @type {number}
     * @memberof RecommendCodeBindPageItemVo
     */
    outboundOrderCount?: number;
    /**
     * 结算金额（附加服务金额合计）
     * @type {number}
     * @memberof RecommendCodeBindPageItemVo
     */
    settlementAmount?: number;
    /**
     * 佣金金额（佣金金额合计，含已结算与未结算）
     * @type {number}
     * @memberof RecommendCodeBindPageItemVo
     */
    commissionAmount?: number;
    /**
     * 推荐码绑定日（会员注册时间）
     * @type {string}
     * @memberof RecommendCodeBindPageItemVo
     */
    bindDate?: string;
}

/**
 * Check if a given object implements the RecommendCodeBindPageItemVo interface.
 */
export function instanceOfRecommendCodeBindPageItemVo(value: object): value is RecommendCodeBindPageItemVo {
    return true;
}

export function RecommendCodeBindPageItemVoFromJSON(json: any): RecommendCodeBindPageItemVo {
    return RecommendCodeBindPageItemVoFromJSONTyped(json, false);
}

export function RecommendCodeBindPageItemVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendCodeBindPageItemVo {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'recommendCode': json['recommendCode'] == null ? undefined : json['recommendCode'],
        'outboundOrderCount': json['outboundOrderCount'] == null ? undefined : json['outboundOrderCount'],
        'settlementAmount': json['settlementAmount'] == null ? undefined : json['settlementAmount'],
        'commissionAmount': json['commissionAmount'] == null ? undefined : json['commissionAmount'],
        'bindDate': json['bindDate'] == null ? undefined : json['bindDate'],
    };
}

export function RecommendCodeBindPageItemVoToJSON(json: any): RecommendCodeBindPageItemVo {
    return RecommendCodeBindPageItemVoToJSONTyped(json, false);
}

export function RecommendCodeBindPageItemVoToJSONTyped(value?: RecommendCodeBindPageItemVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'recommendCode': value['recommendCode'],
        'outboundOrderCount': value['outboundOrderCount'],
        'settlementAmount': value['settlementAmount'],
        'commissionAmount': value['commissionAmount'],
        'bindDate': value['bindDate'],
    };
}

